import { Heading, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { General } from "./components/General";
import { ScopeOne } from "./components/ScopeOne";
import { ScopeTwo } from "./components/ScopeTwo";
import { ScopeThree } from "./components/ScopeThree";
import * as React from "react";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

function Revenue({ data, submitAndReturnToList, setSubmitAndReturnToList, handleNavigationToList, isPreview }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierQuestionnaire"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Fragment>
      <Tabs variant="unstyled" index={tabIndex} onChange={setTabIndex}>
        <TabList
          borderBottom="1px solid"
          borderColor="gray.200"
          sx={{
            "& > button": {
              mb: "-1px",
              py: 3,
              px: 4,
              fontSize: "15px",
              fontWeight: "600",
              color: "gray.400",
              borderBottom: "2px solid transparent",
              _selected: {
                color: "gray.800",
                borderBottom: "2px solid limegreen",
              },
            },
          }}
        >
          <Tab isDisabled={isPreview ? false : tabIndex !== 0}>{t("revenueTabs.general")}</Tab>
          <Tab isDisabled={isPreview ? false : tabIndex !== 1}>{`${t("revenueTabs.scope")} 1`}</Tab>
          <Tab isDisabled={isPreview ? false : tabIndex !== 2}>{`${t("revenueTabs.scope")} 2`}</Tab>
          <Tab isDisabled={isPreview ? false : tabIndex !== 3}>{`${t("revenueTabs.scope")} 3`}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>{t("general.title")}</Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">{t("general.subtitle")}</Text>
            <General
              isTabActive={tabIndex === 0}
              defaultValues={data}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>{t("scopeOne.title")}</Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">{t("scopeOne.subtitle")}</Text>
            <ScopeOne
              isTabActive={tabIndex === 1}
              defaultValues={data}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>{t("scopeTwo.title")}</Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">{t("scopeTwo.subtitle")}</Text>
            <ScopeTwo
              isTabActive={tabIndex === 2}
              defaultValues={data}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
          <TabPanel px={0} pt={6}>
            <Heading as="h2" fontSize="24px" fontWeight="700" color="gray.600" mt={4} mb={2}>{t("scopeThree.title")}</Heading>
            <Text fontSize="14px" color="gray.500" mb={4} maxW="66%">{t("scopeThree.subtitle")}</Text>
            <ScopeThree
              isTabActive={tabIndex === 3}
              id={data.id}
              categories={data.revenue?.categories ?? {}}
              questionnaireType={data.questionnaireType}
              handleTabChange={setTabIndex}
              isPreview={isPreview}
              returnToListRequested={submitAndReturnToList}
              returnToList={handleNavigationToList}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Fragment>
  );
}

export default Revenue;